/* SENZA DIRLO - Provala: la frase ricamata come sara' davvero.
   I dati vengono dal kit: andate a capo vere, combinazioni capo/filo che
   esistono davvero a catalogo. Se una combinazione non c'e', qui non compare. */
window.SD_PROVALA = {
"fili":{"Arancione":"#E2762B","Blu":"#1B3A5F","Nero":"#1C1C1C","Acqua pavone":"#3EA6B8","Bianco":"#FFFFFF","Giallo":"#E8C33E","Rosso":"#C0392B"},
"capi":{"Grigia":"#B4B4B6","Nera":"#1A1A1A","Blu":"#27314F","Bianca":"#F2F1ED","Bianco":"#F2F1ED","Celeste":"#A9C6DE","Nero":"#1A1A1A"},
"prodotti":{
 "fel":{"nome":"Felpa con cappuccio","prezzo":79,"combo":{"Grigia":["Arancione","Blu","Nero"],"Nera":["Arancione","Acqua pavone","Bianco"],"Blu":["Arancione","Bianco","Acqua pavone","Giallo"]}},
 "tso":{"nome":"T-shirt oversize","prezzo":45,"combo":{"Bianca":["Blu","Acqua pavone","Nero","Rosso","Arancione"],"Grigia":["Blu","Nero","Arancione"],"Blu":["Arancione","Bianco","Rosso","Giallo"],"Nera":["Giallo","Arancione","Bianco","Acqua pavone","Rosso"]}},
 "cap":{"nome":"Cappello","prezzo":35,"combo":{"Bianco":["Blu","Acqua pavone","Nero"],"Celeste":["Blu","Rosso"],"Blu":["Acqua pavone","Bianco","Arancione"],"Nero":["Acqua pavone","Bianco","Arancione","Rosso"]}}},
"frasi":[
{"t":"Chiamami","h":"adu01","r":["Chiamami"],"cat":"A due","cap":true},
{"t":"Facciamo tardi","h":"adu02","r":["Facciamo","tardi"],"cat":"A due","cap":true},
{"t":"Dimmi che resti","h":"adu03","r":["Dimmi","che resti"],"cat":"A due","cap":true},
{"t":"Ti porto via","h":"adu04","r":["Ti porto via"],"cat":"A due","cap":true},
{"t":"Poi ti spiego","h":"adu05","r":["Poi","ti spiego"],"cat":"A due","cap":true},
{"t":"Anche domani?","h":"adu06","r":["Anche","domani?"],"cat":"A due","cap":true},
{"t":"Ti aspetto sveglio","h":"adu07","r":["Ti aspetto","sveglio"],"cat":"A due","cap":false},
{"t":"Passo a prenderti","h":"adu08","r":["Passo","a prenderti"],"cat":"A due","cap":false},
{"t":"Resta, fuori piove","h":"adu09","r":["Resta,","fuori piove"],"cat":"A due","cap":false},
{"t":"Ancora cinque minuti","h":"adu10","r":["Ancora","cinque","minuti"],"cat":"A due","cap":false},
{"t":"Solito posto, solita ora","h":"adu11","r":["Solito","posto,","solita ora"],"cat":"A due","cap":false},
{"t":"Quando un tramonto insieme?","h":"adu12","r":["Quando un","tramonto","insieme?"],"cat":"A due","cap":false},
{"t":"Ho sonno","h":"scu01","r":["Ho sonno"],"cat":"Scuse","cap":true},
{"t":"Con calma","h":"scu02","r":["Con calma"],"cat":"Scuse","cap":true},
{"t":"Torno subito","h":"scu03","r":["Torno","subito"],"cat":"Scuse","cap":true},
{"t":"Ci ho provato","h":"scu04","r":["Ci ho","provato"],"cat":"Scuse","cap":true},
{"t":"Niente di che","h":"scu05","r":["Niente","di che"],"cat":"Scuse","cap":true},
{"t":"Prima il caffè","h":"scu06","r":["Prima","il caffè"],"cat":"Scuse","cap":true},
{"t":"Domani sicuro","h":"scu07","r":["Domani","sicuro"],"cat":"Scuse","cap":true},
{"t":"Va bene uguale","h":"scu08","r":["Va bene","uguale"],"cat":"Scuse","cap":true},
{"t":"Ho detto tutto","h":"scu09","r":["Ho detto","tutto"],"cat":"Scuse","cap":true},
{"t":"Sono in ritardo","h":"scu10","r":["Sono","in ritardo"],"cat":"Scuse","cap":true},
{"t":"Bar sotto casa","h":"scu11","r":["Bar sotto","casa"],"cat":"Scuse","cap":true},
{"t":"Sono già stanco","h":"scu12","r":["Sono già","stanco"],"cat":"Scuse","cap":true},
{"t":"Ho quasi finito","h":"scu13","r":["Ho quasi","finito"],"cat":"Scuse","cap":true},
{"t":"Adesso non mi va","h":"scu14","r":["Adesso","non mi va"],"cat":"Scuse","cap":false},
{"t":"Ci penso domani","h":"scu15","r":["Ci penso","domani"],"cat":"Scuse","cap":false},
{"t":"Poteva andare peggio","h":"scu16","r":["Poteva","andare","peggio"],"cat":"Scuse","cap":false},
{"t":"Faccio finta di niente","h":"scu17","r":["Faccio finta","di niente"],"cat":"Scuse","cap":false},
{"t":"Contento tu","h":"car01","r":["Contento tu"],"cat":"Carattere","cap":true},
{"t":"Non insisto","h":"car02","r":["Non insisto"],"cat":"Carattere","cap":true},
{"t":"Fai come vuoi","h":"car03","r":["Fai come","vuoi"],"cat":"Carattere","cap":true},
{"t":"Peggio per te","h":"car04","r":["Peggio","per te"],"cat":"Carattere","cap":true},
{"t":"Se lo dici tu","h":"car05","r":["Se lo dici tu"],"cat":"Carattere","cap":true},
{"t":"Non ti riguarda","h":"car06","r":["Non","ti riguarda"],"cat":"Carattere","cap":true},
{"t":"Sole in faccia","h":"acq01","r":["Sole","in faccia"],"cat":"Acqua","cap":true},
{"t":"Mare d'inverno","h":"acq02","r":["Mare","d'inverno"],"cat":"Acqua","cap":true},
{"t":"Ancora un bagno","h":"acq03","r":["Ancora","un bagno"],"cat":"Acqua","cap":false},
{"t":"Portami al largo","h":"acq04","r":["Portami","al largo"],"cat":"Acqua","cap":true},
{"t":"Il mare mi aspetta","h":"acq05","r":["Il mare","mi aspetta"],"cat":"Acqua","cap":false},
{"t":"Ci vediamo al mare","h":"acq06","r":["Ci vediamo","al mare"],"cat":"Acqua","cap":false},
{"t":"Altrove","h":"par01","r":["Altrove"],"cat":"Partenze","cap":true},
{"t":"Solo andata","h":"par02","r":["Solo","andata"],"cat":"Partenze","cap":true},
{"t":"Parto leggero","h":"par03","r":["Parto","leggero"],"cat":"Partenze","cap":true},
{"t":"Non torno a casa","h":"par04","r":["Non torno","a casa"],"cat":"Partenze","cap":false},
{"t":"Ho perso il treno","h":"par05","r":["Ho perso","il treno"],"cat":"Partenze","cap":false},
{"t":"Casa è dove torno","h":"par06","r":["Casa è dove","torno"],"cat":"Partenze","cap":false},
{"t":"Torno quando torno","h":"par07","r":["Torno","quando","torno"],"cat":"Partenze","cap":false},
{"t":"Domani sono altrove","h":"par08","r":["Domani","sono","altrove"],"cat":"Partenze","cap":false},
{"t":"Scendo alla prossima","h":"par09","r":["Scendo alla","prossima"],"cat":"Partenze","cap":false},
{"t":"Solo bagaglio a mano","h":"par10","r":["Solo","bagaglio","a mano"],"cat":"Partenze","cap":false},
{"t":"Resto un altro giorno","h":"par11","r":["Resto","un altro","giorno"],"cat":"Partenze","cap":false},
{"t":"Ci vediamo in montagna","h":"par12","r":["Ci vediamo","in","montagna"],"cat":"Partenze","cap":false},
{"t":"Non chiedo indicazioni","h":"par13","r":["Non chiedo","indicazioni"],"cat":"Partenze","cap":false},
{"t":"Andiamo a vedere l'alba","h":"par14","r":["Andiamo","a vedere","l'alba"],"cat":"Partenze","cap":false},
{"t":"Mi sono perso volentieri","h":"par15","r":["Mi sono","perso","volentieri"],"cat":"Partenze","cap":false},
{"t":"Ho perso il treno apposta","h":"par16","r":["Ho perso","il treno","apposta"],"cat":"Partenze","cap":false},
{"t":"Senza cronometro","h":"pas01","r":["Senza","cronometro"],"cat":"Passi","cap":false},
{"t":"Piano, ma sempre","h":"pas02","r":["Piano,","ma sempre"],"cat":"Passi","cap":false},
{"t":"Non sto scappando","h":"pas03","r":["Non sto","scappando"],"cat":"Passi","cap":false},
{"t":"Anche oggi, presto","h":"pas04","r":["Anche oggi,","presto"],"cat":"Passi","cap":false},
{"t":"Ci vediamo all'alba","h":"pas05","r":["Ci vediamo","all'alba"],"cat":"Passi","cap":false},
{"t":"Nessuno mi rincorre","h":"pas06","r":["Nessuno","mi rincorre"],"cat":"Passi","cap":false},
{"t":"Corro per stare zitto","h":"pas07","r":["Corro per","stare zitto"],"cat":"Passi","cap":false},
{"t":"Le gambe si ricordano","h":"pas08","r":["Le gambe si","ricordano"],"cat":"Passi","cap":false},
{"t":"Sempre la stessa strada","h":"pas09","r":["Sempre","la stessa","strada"],"cat":"Passi","cap":false},
{"t":"Il primo chilometro è il peggiore","h":"pas10","r":["Il primo","chilometro","è il peggiore"],"cat":"Passi","cap":false},
{"t":"Solo un giro","h":"pas11","r":["Solo un giro"],"cat":"Passi","cap":true},
{"t":"Testa bassa","h":"pas12","r":["Testa bassa"],"cat":"Passi","cap":true},
{"t":"Non è una gara","h":"pas13","r":["Non è","una gara"],"cat":"Passi","cap":true},
{"t":"Piove, esco uguale","h":"pas14","r":["Piove,","esco uguale"],"cat":"Passi","cap":false},
{"t":"Mi passa correndo","h":"pas15","r":["Mi passa","correndo"],"cat":"Passi","cap":false},
{"t":"Mi aspetti al traguardo?","h":"pas16","r":["Mi","aspetti al","traguardo?"],"cat":"Passi","cap":false},
{"t":"Ultimo, ma c'ero","h":"pas17","r":["Ultimo,","ma c'ero"],"cat":"Passi","cap":true}
]};

window.SDProvala = function(id){
  "use strict";
  var D = window.SD_PROVALA;
  var root = document.getElementById(id);
  if(!root || !D){ return; }
  var NS = "http://www.w3.org/2000/svg";

  var selFrase = root.querySelector("[data-frase]");
  var rigaCapo = root.querySelector("[data-capi]");
  var rigaCol  = root.querySelector("[data-colori]");
  var rigaFilo = root.querySelector("[data-fili]");
  var testo    = root.querySelector("[data-testo]");
  var gruppo   = root.querySelector("[data-gruppo]");
  var stoffa   = root.querySelector("[data-stoffa]");
  var vai      = root.querySelector("[data-vai]");
  var didasc   = root.querySelector("[data-didascalia]");
  if(!selFrase || !testo){ return; }

  var stato = { frase: D.frasi[0], capo: "fel", colore: null, filo: null };

  // elenco frasi raggruppate per famiglia
  var fam = {};
  D.frasi.forEach(function(f){ (fam[f.cat] = fam[f.cat] || []).push(f); });
  Object.keys(fam).forEach(function(cat){
    var g = document.createElement("optgroup"); g.label = cat;
    fam[cat].forEach(function(f){
      var o = document.createElement("option"); o.value = f.h; o.textContent = f.t; g.appendChild(o);
    });
    selFrase.appendChild(g);
  });

  function bottone(riga, etichetta, valore, colore, attivo, spento){
    var b = document.createElement("button");
    b.type = "button";
    b.className = "pv-scelta" + (colore ? " pv-pastiglia" : "") + (attivo ? " pv-attiva" : "") + (spento ? " pv-spenta" : "");
    b.setAttribute("data-valore", valore);
    if(spento){ b.disabled = true; b.title = "Non esiste in catalogo"; }
    if(colore){
      b.style.setProperty("--tinta", colore);
      b.innerHTML = "<span class='pv-bolla'></span><span class='pv-nome'>" + etichetta + "</span>";
    } else {
      b.textContent = etichetta;
    }
    riga.appendChild(b);
    return b;
  }

  function combo(){ return D.prodotti[stato.capo].combo; }

  function disegnaCapi(){
    rigaCapo.innerHTML = "";
    ["fel","tso","cap"].forEach(function(k){
      var spento = (k === "cap" && !stato.frase.cap);
      var b = bottone(rigaCapo, D.prodotti[k].nome, k, null, k === stato.capo, spento);
      if(!spento){ b.addEventListener("click", function(){ stato.capo = k; stato.colore = null; stato.filo = null; tutto(); }); }
    });
  }

  function disegnaColori(){
    var c = combo();
    var chiavi = Object.keys(c);
    if(chiavi.indexOf(stato.colore) < 0){ stato.colore = chiavi[0]; }
    rigaCol.innerHTML = "";
    chiavi.forEach(function(k){
      var b = bottone(rigaCol, k, k, D.capi[k] || "#999", k === stato.colore, false);
      b.addEventListener("click", function(){ stato.colore = k; stato.filo = null; tutto(); });
    });
  }

  function disegnaFili(){
    var lista = combo()[stato.colore] || [];
    if(lista.indexOf(stato.filo) < 0){ stato.filo = lista[0]; }
    rigaFilo.innerHTML = "";
    lista.forEach(function(k){
      var b = bottone(rigaFilo, k, k, D.fili[k] || "#999", k === stato.filo, false);
      b.addEventListener("click", function(){ stato.filo = k; tutto(); });
    });
  }

  function disegnaRicamo(){
    stoffa.setAttribute("fill", D.capi[stato.colore] || "#ccc");
    root.style.setProperty("--filo", D.fili[stato.filo] || "#333");

    while(testo.firstChild){ testo.removeChild(testo.firstChild); }
    var righe = stato.frase.r || [stato.frase.t];
    var passo = 116;
    righe.forEach(function(r, i){
      var ts = document.createElementNS(NS, "tspan");
      ts.setAttribute("x", 0);
      ts.setAttribute("y", (i - (righe.length - 1) / 2) * passo);
      ts.textContent = r;
      testo.appendChild(ts);
    });

    gruppo.setAttribute("transform", "translate(320,190)");
    var b;
    try{ b = testo.getBBox(); }catch(e){ b = null; }
    if(b && b.width){
      var s = Math.min(430 / b.width, 210 / b.height, 1.15);
      var cx = b.x + b.width / 2, cy = b.y + b.height / 2;
      gruppo.setAttribute("transform", "translate(320,190) scale(" + s.toFixed(3) + ") translate(" + (-cx).toFixed(1) + "," + (-cy).toFixed(1) + ")");
    }
  }

  function disegnaVai(){
    var p = D.prodotti[stato.capo];
    var url = "/products/sd-" + stato.frase.h + "-" + stato.capo +
              "?Colore=" + encodeURIComponent(stato.colore) +
              "&Ricamo=" + encodeURIComponent(stato.filo);
    vai.setAttribute("href", url);
    vai.textContent = "Vai a questa " + (stato.capo === "cap" ? "cappello" : (stato.capo === "fel" ? "felpa" : "t-shirt")) + " — " + p.prezzo + ",00 €";
    if(didasc){
      didasc.textContent = p.nome + " " + stato.colore.toLowerCase() + ", ricamo " + stato.filo.toLowerCase() + ".";
    }
  }

  function tutto(){ disegnaCapi(); disegnaColori(); disegnaFili(); disegnaRicamo(); disegnaVai(); }

  selFrase.addEventListener("change", function(){
    var h = selFrase.value;
    for(var i = 0; i < D.frasi.length; i++){ if(D.frasi[i].h === h){ stato.frase = D.frasi[i]; break; } }
    if(stato.capo === "cap" && !stato.frase.cap){ stato.capo = "fel"; stato.colore = null; stato.filo = null; }
    tutto();
  });

  selFrase.value = stato.frase.h;
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(tutto).catch(tutto); }
  setTimeout(tutto, 1200);
  tutto();
};
